import * as React from 'react';

const PendingIssuerVerificationRequests = () => (
  <React.Fragment>
    <h1 className="title is-1 has-centered-text">New Verification Request</h1>
  </React.Fragment>
);

export default PendingIssuerVerificationRequests;
